import { onCLS, onINP, onFCP, onLCP, onTTFB, type Metric } from 'web-vitals'

export const reportWebVitals = () => {
  const sendToAnalytics = (metric: Metric) => {
    // Google Analytics
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', metric.name, {
        event_category: 'Web Vitals',
        event_label: metric.id,
        value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
        non_interaction: true,
      })
    }
    
    // Console para debug (apenas em desenvolvimento)
    if (import.meta.env.DEV) {
      console.log(`🚀 Web Vital - ${metric.name}:`, {
        value: metric.value,
        rating: metric.rating,
        delta: metric.delta,
        id: metric.id
      })
    }

  }

  // Monitorar todas as métricas Core Web Vitals
  onCLS(sendToAnalytics)
  onINP(sendToAnalytics) // INP substituiu FID na versão 5+
  onFCP(sendToAnalytics)
  onLCP(sendToAnalytics)
  onTTFB(sendToAnalytics)
}

// Função para reportar métricas customizadas
export const reportCustomMetric = (name: string, value: number, label?: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'custom_metric', {
      event_category: 'Performance',
      event_label: label || name,
      value: Math.round(value),
      custom_parameter_name: name
    })
  }
}

// Monitorar tempo de carregamento de recursos específicos
export const measureResourceTiming = (resourceName: string) => {
  if (typeof window !== 'undefined' && 'performance' in window) {
    const observer = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        if (entry.name.includes(resourceName)) {
          reportCustomMetric(`resource_${resourceName}`, entry.duration, entry.name)
        }
      }
    })
    
    observer.observe({ entryTypes: ['resource'] })
  }
}